import { cmsUrl } from '@helpers/environment';

const prefixUploadUrl = (path) => {
  return typeof cmsUrl === `string` && cmsUrl.length > 0
    ? `${cmsUrl}${path}`
    : path;
};

export default prefixUploadUrl;
